import React, { useState, useEffect } from "react";
import { Card, Button, Modal } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import DataTable from "react-data-table-component";
import moment from 'moment';

// ✅ Mocked data
const dummySubscribers = [
  {
    _id: "sub_001",
    userId: {
      username: "john_doe",
      email: "john@example.com"
    },
    subscriptionId: {
      planName: "Premium"
    },
    startDate: "2024-12-01T00:00:00Z",
    renewalDate: "2025-12-01T00:00:00Z"
  },
  {
    _id: "sub_002",
    userId: {
      username: "jane_smith",
      email: "jane@example.com"
    },
    subscriptionId: {
      planName: "Standard"
    },
    startDate: "2025-01-15T00:00:00Z",
    renewalDate: "2026-01-15T00:00:00Z"
  },
  {
    _id: "sub_003",
    userId: {
      username: "rohit_gupta",
      email: "rohit@example.com"
    },
    subscriptionId: {
      planName: "Basic"
    },
    startDate: "2025-03-10T00:00:00Z",
    renewalDate: "2026-03-10T00:00:00Z"
  },
  {
    _id: "sub_004",
    userId: {
      username: "emily_jones",
      email: "emily@example.com"
    },
    subscriptionId: {
      planName: "Premium"
    },
    startDate: "2025-04-20T00:00:00Z",
    renewalDate: "2026-04-20T00:00:00Z"
  },
  {
    _id: "sub_005",
    userId: {
      username: "mike_lee",
      email: "mike@example.com"
    },
    subscriptionId: {
      planName: "Enterprise"
    },
    startDate: "2025-05-01T00:00:00Z",
    renewalDate: "2026-05-01T00:00:00Z"
  }
];

// ✅ Mock API methods
const getSubscribersList = () => {
  return Promise.resolve({ data: dummySubscribers });
};

const deleteSubscriber = ({ subscriberId }) => {
  return Promise.resolve({ data: { success: true, subscriberId } });
};

export default function Subscribers() {
  const [searchText, setSearchText] = useState('');
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [subscriberToDelete, setSubscriberToDelete] = useState(null);

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = () => {
    setLoading(true);
    getSubscribersList()
      .then((response) => {
        if (response.data) {
          setSubscribers(response.data);
        }
      })
      .catch((error) => console.error("Error fetching subscribers", error))
      .finally(() => setLoading(false));
  };

  const handleDeleteSubscriber = () => {
    if (!subscriberToDelete) return;

    deleteSubscriber({ subscriberId: subscriberToDelete })
      .then((response) => {
        if (response.data) {
          setSubscribers(prevSubscribers =>
            prevSubscribers.filter(sub => sub._id !== subscriberToDelete)
          );
          setShowDeleteModal(false);
          setSubscriberToDelete(null);
        }
      })
      .catch((error) => {
        console.error("Error deleting subscriber", error);
        alert("Failed to delete subscriber. Please try again.");
      });
  };

  const handleShowDeleteModal = (id) => {
    setSubscriberToDelete(id);
    setShowDeleteModal(true);
  };

  const columns = [
    {
      name: 'Subscriber ID',
      width: '250px',
      selector: row => row._id,
      sortable: true,
    },
    // {
    //   name: 'Username',
    //   width: '160px',
    //   selector: row => row.userId.username,
    //   sortable: true,
    // },
    {
      name: 'Email Address',
      width: '270px',
      selector: row => row.userId.email || 'N/A',
      sortable: true,
    },
    {
      name: 'Subscription Plan',
      width: '180px',
      selector: row => row.subscriptionId.planName,
      sortable: true,
    },
    {
      name: 'Start Date',
      width: '140px',
      selector: row => row.startDate,
      sortable: true,
      cell: row => moment(row.startDate).format('YYYY-MM-DD'),
    },
    {
      name: 'Renewal Date',
      width: '150px',
      selector: row => row.renewalDate,
      sortable: true,
      cell: row => moment(row.renewalDate).format('YYYY-MM-DD'),
    },
    {
      name: 'Actions',
      cell: row => (
        <button className="btn btn-danger" onClick={() => handleShowDeleteModal(row._id)}>
         <Icon icon="tabler:trash"></Icon>
        </button>
      ),
    },
  ];

  const filteredData = subscribers.filter(item => {
    const searchStr = searchText.toLowerCase();
    return (
      item.userId.username.toLowerCase().includes(searchStr) ||
      item.subscriptionId.planName.toLowerCase().includes(searchStr) ||
      item._id.toLowerCase().includes(searchStr)
    );
  });

  return (
    <>
      <Card>
        <Card.Header className="py-4">
          <h5>Subscribers</h5>
        </Card.Header>
        <Card.Body>
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
            />
          </div>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            responsive
            className="custom-table"
            progressPending={loading}
            noDataComponent="No subscribers found"
          />
        </Card.Body>
      </Card>

      {/* Delete Modal */}
      <Modal className="modal_Delete" show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Body>
          <div className="modaldelete_div text-center mb-3">
            <Icon className="delete_icon" icon="gg:close-o" style={{ fontSize: '2rem' }} />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <div className="d-flex justify-content-center">
            <Button onClick={() => setShowDeleteModal(false)} className="btn btn-outline-primary px-4 me-3">
              Cancel
            </Button>
            <Button className="btn btn-primary px-4" onClick={handleDeleteSubscriber}>
              Ok
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
